exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-item--disabled,.v-item--disabled *{pointer-events:none}", ""]);

// exports
